export enum TokenKeysConfig {
  TokenKey = 'accessToken',
  RefreshTokenKey = 'refreshToken',
  CSRFTokenKey = 'CSRF-TOKEN',
}
